import { assetsAxios } from '@/features/assets/api/client'
import { ENDPOINTS } from '@/features/assets/api/endpoints'
import type { ApiResponse, Portfolio, PortfoliosResponse, PortfolioShare } from '@/features/assets/api/types'

export const portfoliosAPI = {
  list: async (): Promise<ApiResponse<PortfoliosResponse>> => {
    const res = await assetsAxios.get(ENDPOINTS.portfolios)
    return res.data
  },
  create: async (data: Record<string, unknown>): Promise<ApiResponse<Portfolio>> => {
    const res = await assetsAxios.post(ENDPOINTS.portfolios, data)
    return res.data
  },
  get: async (id: number): Promise<ApiResponse<Portfolio>> => {
    const res = await assetsAxios.get(ENDPOINTS.portfolio(id))
    return res.data
  },
  update: async (id: number, data: Record<string, unknown>): Promise<ApiResponse<Portfolio>> => {
    const res = await assetsAxios.patch(ENDPOINTS.portfolio(id), data)
    return res.data
  },
  delete: async (id: number): Promise<void> => {
    await assetsAxios.delete(ENDPOINTS.portfolio(id))
  },
  getShares: async (id: number): Promise<ApiResponse<PortfolioShare[]>> => {
    const res = await assetsAxios.get(ENDPOINTS.portfolioShares(id))
    return res.data
  },
  share: async (id: number, data: { user_id: string; role?: string }): Promise<ApiResponse<PortfolioShare>> => {
    const res = await assetsAxios.post(ENDPOINTS.portfolioShares(id), data)
    return res.data
  },
  updateShare: async (id: number, userId: string, data: { role: string }): Promise<ApiResponse<PortfolioShare>> => {
    const res = await assetsAxios.patch(ENDPOINTS.portfolioShare(id, userId), data)
    return res.data
  },
  revokeShare: async (id: number, userId: string): Promise<void> => {
    await assetsAxios.delete(ENDPOINTS.portfolioShare(id, userId))
  },
  transfer: async (id: number, data: { user_id: string }): Promise<ApiResponse<Portfolio>> => {
    const res = await assetsAxios.post(ENDPOINTS.portfolioTransfer(id), data)
    return res.data
  },
}
